<template>
  <base-floating-card @close="close">
    <time-picker
      :date="date"
      :heading="heading"
      :initialValue="initialValue"
      :processing="processing"
      @close="close"
      @input="input"
    />
  </base-floating-card>
</template>
<script>
import BaseFloatingCard from "../BaseFloatingCard.vue";

import TimePicker from "../../../Elements/TimePicker.vue";
export default {
  data() {
    return {
      value: undefined,
    };
  },
  methods: {
    input(val) {
      this.value = val;
    },
    close() {
      this.$emit("close", this.value);
    },
  },
  components: {
    BaseFloatingCard,
    TimePicker,
  },
  props: ["initialValue", "date", "processing", "heading"],
  emits: ["close"],
};
</script>
<style scoped></style>
